<template>
  <div id="detailCar">
    <div class="detailCarBox">
      <!-- <Breadcrumb class="breadcrumb" :lastBread="pageData.name"></Breadcrumb> -->
      <div class="routerNameBox">
        <div class="routerItem">
          <router-link to="/mall" class="name"> 首页 </router-link>
          <span class="namePre">></span>
        </div>
        <div class="routerItem">
          <router-link class="name" to="/seller/mallCar">全线车系</router-link>
          <span class="namePre">></span>
        </div>
        <div class="routerItem">
          <span class="name">{{ pageData.name }}</span>
        </div>
      </div>
      <div class="selectBox">
        <div class="leftBox">
          <car
            :key="carOutList.length + carInUrl.length"
            :outList="carOutList"
            :inUrlList="carInUrl"
          ></car>
        </div>
        <div class="rightBox">
          <div class="titleBox">
            <span class="title">{{ pageData.name }}</span>
            <!-- <img v-if="activityType == 18" class="deposit-tag" src="../../assets/images/activity/deposit-tag.png" /> -->
            <!-- 订金升档-订金 -->
            <span class="title-right" v-if="activityType == 18">
              <span class="text">订金</span>
              <span class="price">{{
                this.activityId
                  ? Number(activityPrice)
                  : Number(selectSkuData.price) | currency("￥", 2)
              }}</span>
            </span>
            <div class="message">{{ pageData.message }}</div>
            <div
              class="recommend"
              v-if="
                !!pageData.activityItemInfoDto.activityInfoDto &&
                isActivity &&
                activityType !== 3 &&
                activityType !== 22 &&
                activityType !== 25
              "
            >
              {{ pageData.activityItemInfoDto.activityInfoDto.activityTag }}
            </div>
            <div
              class="luckyTab"
              v-if="activityTypeCode === 'lotteryDraw'"
            ></div>
            <!--抽奖标签-->
          </div>
          <div class="clear"></div>
          <div
            :class="activityType == 18 ? 'deposit-advertise' : 'advertise'"
            v-if="!isActivity || activityType == 3"
          >
            {{ pageData.advertise }}
          </div>
          <!-- 买赠描述 -->
          <div class="gift-advertise" v-if="activityType == 21">
            {{
              _get(pageData, "activityItemInfoDto.activityInfoDto.activityDesc")
            }}
          </div>
          <Deposit
            v-if="
              pageData.activityItemInfoDto.activityInfoDto.activityType == 18
            "
            :activityItemInfoDto="pageData.activityItemInfoDto"
            :selectSkuData="selectSkuData"
            :now="now"
            :activityQuantity="activityQuantity"
          ></Deposit>
          <template
            v-if="
              pageData.activityItemInfoDto &&
              pageData.activityItemInfoDto.activityInfoDto &&
              pageData.activityItemInfoDto.activityInfoDto.activityType !==
                20 &&
              pageData.activityItemInfoDto.activityInfoDto.activityType !== 25
            "
          >
            <Activity
              v-if="
                isActivity &&
                activityType !== 18 &&
                activityType !== 21 &&
                activityType !== 2 &&
                activityType !== 3
              "
              :activityItemInfoDto="pageData.activityItemInfoDto"
              :selectSkuData="selectSkuData"
              :now="now"
              :activityQuantity="activityQuantity"
              :activityType="
                pageData.activityItemInfoDto &&
                pageData.activityItemInfoDto.activityInfoDto &&
                pageData.activityItemInfoDto.activityInfoDto.activityType
              "
              :joinNum="
                pageData.activityItemInfoDto &&
                pageData.activityItemInfoDto.groupPurchaseLadderDto &&
                pageData.activityItemInfoDto.groupPurchaseLadderDto.joinNum
              "
            ></Activity>
          </template>
          <template v-else>
            <!-- 拍卖的倒计时显示 -->
            <AuctionInformation
              v-if="activityType == 20"
              :activityItemInfoDto="pageData.activityItemInfoDto"
              :selectSkuData="selectSkuData"
              :watchCount="watchCount"
              :activityData="activityData"
              :now="now"
              :activityQuantity="activityQuantity"
              :auctionState="getAuctionState"
              :isFreeFall="isFreeFall"
              :earnest="firstSku.price"
              :goodsType="pageData.type"
            >
            </AuctionInformation
          ></template>
          <div
            class="priceBox"
            v-if="
              !isActivity ||
              (isActivity &&
                pageData.activityItemInfoDto.activityInfoDto.activityType !==
                  20) ||
              (activityType !== 18 && activityType !== 20)
            "
          >
            <div
              class="price priceItem"
              v-if="pageData && pageData.extra && pageData.extra.originPrice"
            >
              <span class="title">官方指导价</span>
              <span class="num">
                {{ pageData && pageData.extra && pageData.extra.originPrice }}

                <!-- {{
                  Number(
                    selectSkuData && selectSkuData.extraPrice && selectSkuData.extraPrice.guidePrice
                      ? selectSkuData && selectSkuData.extraPrice && selectSkuData.extraPrice.guidePrice
                      : pageData && pageData.extra && pageData.extra.originPrice
                  ) | currency('￥', 0)
                }} -->
                <!-- {{ Number(pageData.lowPrice) | currency('￥', 2) }}~{{ Number(pageData.highPrice) | currency('', 2) }} -->
              </span>
            </div>

            <div class="price priceItem newPrice">
              <span class="title">订金</span>
              <span class="num">
                {{
                  this.activityId && activityType !== 3 && activityType !== 22
                    ? Number(activityPrice)
                    : Number(selectSkuData.price) | currency("￥", 2)
                }}
              </span>
            </div>
          </div>
          <!--s 拍卖价格区域 如果拍卖还未开始不显示-->
          <div v-if="activityType == 20 && !isFreeFall" class="priceAuction">
            <div
              v-if="_get(this.pageData, 'extra.originPrice', 0) !== 0"
              class="OfficialGuidePriceBox"
            >
              <span class="title">官方指导价</span>
              <span class="num">
                ￥{{ _get(this.pageData, "extra.originPrice", 0) }}
              </span>
            </div>
            <!-- 拍卖活动结束 -->
            <div
              v-if="
                getAuctionState === 2 &&
                pageData.activityItemInfoDto.auctionDto.orderFlag
              "
              class="tranPriceBox"
            >
              <span class="title">成交价</span>
              <span class="transactionPrice">
                {{ currentOfferPrice | currency("￥", 2) }}
              </span>
            </div>
          </div>
          <!--e 拍卖价格区域 -->
          <div v-if="activityType == 18">
            <DepositDesc
              class="depositdesc"
              :preSaleDto="preSaleDto"
              @selectIndex="getSelectIndex"
              @orderAmount="getOrderAmount"
              @ifOrder="getIfOrder"
            />
            <div
              class="guide"
              v-if="pageData && pageData.extra && pageData.extra.originPrice"
            >
              <span class="title">官方指导价</span>
              <span class="num"
                >￥{{
                  pageData && pageData.extra && pageData.extra.originPrice
                }}</span
              >
            </div>
          </div>
          <!-- 进度条 -->
          <div
            class="progress-bar"
            v-if="
              pageData.activityItemInfoDto.activityInfoDto &&
              pageData.activityItemInfoDto.groupPurchaseLadderDto
            "
          >
            <div class="progress-top">
              <span
                class="progress-text"
                v-if="
                  now <
                  pageData.activityItemInfoDto.activityInfoDto.realStartTime
                "
                >未开始</span
              >
              <span class="progress-text-begin" v-else>{{
                pageData.activityItemInfoDto.ifDisplayDiscounts ? "已优惠" : ""
              }}</span>
              <span
                class="progress-text"
                v-for="elm in pageData.activityItemInfoDto
                  .groupPurchaseLadderDto.ladder"
                :key="elm.ladderNo"
                style="text-align: right"
                >{{
                  pageData.activityItemInfoDto &&
                  pageData.activityItemInfoDto.ifDisplayDiscounts
                    ? "￥" + elm.favorablePrice / 100
                    : ""
                }}</span
              >
              <!-- 占位 -->
              <span
                class="progress-text"
                v-if="pageData.activityItemInfoDto.ifDisplayDiscounts == false"
              ></span>
            </div>
            <div class="progress-center">
              <el-progress
                :color="customColorMethod"
                :show-text="false"
                :stroke-width="12"
                :percentage="groupRate(pageData)"
                :show-pivot="false"
                :stroke-linecap="'square'"
              ></el-progress>
              <div
                class="white-line"
                v-if="
                  pageData.activityItemInfoDto.groupPurchaseLadderDto.ladder &&
                  pageData.activityItemInfoDto.groupPurchaseLadderDto.ladder
                    .length > 1
                "
              ></div>
            </div>
            <div class="progress-bottom">
              <span class="progress-text">还差</span>
              <span
                class="progress-text"
                v-for="elm in pageData.activityItemInfoDto
                  .groupPurchaseLadderDto.ladder"
                :key="elm.ladderNo"
                style="text-align: right"
                >{{
                  pageData.activityItemInfoDto.activityInfoDto.id ==
                    "1283753320908849152" ||
                  pageData.activityItemInfoDto.activityInfoDto.id ==
                    "1283744971492425728" ||
                  pageData.activityItemInfoDto.activityInfoDto.id ==
                    "1308247897355059200"
                    ? 0
                    : elm.needNum
                }}人</span
              >
            </div>
          </div>
          <!-- <span class="progress-text">400人</span></div -->
          <!-- 竞拍加价 -->
          <!-- 当前是拍卖类型 活动还没开始不显示-->
          <div
            class="price-content"
            v-if="activityType == 20 && getAuctionState === 1 && !isFreeFall"
          >
            <div class="price-increase">
              <div class="title">当前价</div>
              <div class="now-price">
                <span
                  v-if="
                    pageData.activityItemInfoDto &&
                    pageData.activityItemInfoDto.auctionDto
                  "
                  >¥{{ currentOfferPrice / 100 }}
                </span>
                <span class="lead" v-if="showText.show">{{
                  showText.text
                }}</span>
              </div>
            </div>
            <div class="price-num-box" v-if="isBond">
              <div class="title">出价</div>
              <el-input-number
                v-model="bid"
                size="mini"
                :precision="2"
                :min="bidNumber"
                :step="
                  Number(
                    pageData.activityItemInfoDto.auctionDto.increasePrice / 100
                  )
                "
                label="描述文字"
              />
            </div>
          </div>

          <!-- 降价拍倒计时信息 -->
          <div class="price-content" v-if="isFreeFall && isAuction">
            <div class="price-increase">
              <div style="display: flex">
                <div
                  class="title"
                  v-if="
                    now <
                    pageData.activityItemInfoDto.activityInfoDto.realStartTime
                  "
                >
                  起拍价
                </div>
                <div
                  class="title"
                  v-if="
                    pageData.activityItemInfoDto.activityInfoDto.realStartTime <
                      now && activityStatus !== 2
                  "
                >
                  当前价
                </div>
                <div
                  class="title"
                  v-if="
                    activityStatus === 2 &&
                    pageData.activityItemInfoDto.auctionDto.orderFlag
                  "
                >
                  成交价
                </div>
                <div class="now-price">
                  <span
                    v-if="
                      now <
                      pageData.activityItemInfoDto.activityInfoDto.realStartTime
                    "
                    >¥{{
                      pageData.activityItemInfoDto.auctionDto.rpAuctionRuleDto
                        .startPrice / 100
                    }}</span
                  >
                  <span
                    v-if="
                      isRefresh &&
                      pageData.activityItemInfoDto.activityInfoDto
                        .realStartTime < now &&
                      activityStatus !== 2
                    "
                    >¥{{ this.getFreeFall(auctionData, 1).toFixed(2) }}
                  </span>
                  <span
                    v-if="
                      activityStatus === 2 &&
                      pageData.activityItemInfoDto.auctionDto.orderFlag
                    "
                    >¥{{
                      pageData.activityItemInfoDto.auctionDto.currentPrice / 100
                    }}
                  </span>
                </div>
              </div>
              <div class="time-title">
                <FreeCountdown
                  v-if="
                    isRefresh &&
                    getFreeFall(auctionData, 0) &&
                    pageData.activityItemInfoDto &&
                    pageData.activityItemInfoDto.auctionDto &&
                    pageData.activityItemInfoDto.auctionDto
                      .reducePriceAuction &&
                    pageData.activityItemInfoDto.activityInfoDto &&
                    pageData.activityItemInfoDto.activityInfoDto
                      .activityStatus !== 2 &&
                    pageData.activityItemInfoDto.activityInfoDto.realEndTime >
                      now &&
                    now >
                      pageData.activityItemInfoDto.activityInfoDto.realStartTime
                  "
                  class="time-countdown"
                  :backgroundColor="''"
                  :color="
                    pageData.activityItemInfoDto &&
                    pageData.activityItemInfoDto.activityInfoDto &&
                    pageData.activityItemInfoDto.activityInfoDto.realStartTime >
                      now
                      ? '#ff6723'
                      : '#C6001F'
                  "
                  :splitorColor="
                    pageData.activityItemInfoDto &&
                    pageData.activityItemInfoDto.activityInfoDto &&
                    pageData.activityItemInfoDto.activityInfoDto.realStartTime >
                      now
                      ? '#ff6723'
                      : '#C6001F'
                  "
                  :showColon="false"
                  @timeup="overFree"
                  :activityStatus="
                    pageData.activityItemInfoDto &&
                    pageData.activityItemInfoDto.activityInfoDto &&
                    pageData.activityItemInfoDto.activityInfoDto.activityStatus
                  "
                  :actStartTime="
                    pageData.activityItemInfoDto &&
                    pageData.activityItemInfoDto.activityInfoDto &&
                    pageData.activityItemInfoDto.activityInfoDto.realStartTime
                  "
                  :actEndTime="
                    pageData.activityItemInfoDto &&
                    pageData.activityItemInfoDto.activityInfoDto &&
                    pageData.activityItemInfoDto.activityInfoDto.realEndTime
                  "
                  :second="Number(getFreeFall(auctionData, 0).toFixed(2))"
                ></FreeCountdown>
                <div class="time-title" v-else>
                  {{
                    pageData.activityItemInfoDto.activityInfoDto
                      .activityStatus === 2 ||
                    pageData.activityItemInfoDto.activityInfoDto.realStartTime >
                      now
                      ? ""
                      : " 已降至最低成交价"
                  }}
                </div>
              </div>
            </div>
            <div
              class="guide"
              v-if="pageData && pageData.extra && pageData.extra.originPrice"
            >
              <span class="title">官方指导价</span>
              <span class="num" style="margin-left: 10px">
                ¥{{
                  pageData && pageData.extra && pageData.extra.originPrice
                }}</span
              >
            </div>
          </div>

          <!-- 卡券 -->
          <Coupon
            v-if="couponList && !isActivity && !isBond"
            :couponList="couponList"
            :selectCoupon="selectCoupon"
          ></Coupon>
          <!-- sku -->
          <div class="operationArea">
            <div class="skuBox" v-if="!(isBond && getAuctionState == 1)">
              <sku :skuData="skuData" :callback="getDataSKU"> </sku>
            </div>

            <div
              class="dealer"
              v-if="
                pageData.activityItemInfoDto.activityInfoDto
                  ? pageData.activityItemInfoDto.activityInfoDto
                      .activityType === 20
                    ? !isBond
                      ? true
                      : false
                    : true
                  : true
              "
              @click="dealer = true"
            >
              <div>经销商</div>
              <div class="dealerInput" :style="{ background: !dealerName }">
                {{ dealerName ? dealerName : "选择经销商" }}
              </div>
            </div>

            <div class="numBox" v-if="!(isBond && getAuctionState == 1)">
              <div class="title" style="width: 64px">数量</div>
              <el-input-number
                v-model="numberGoods"
                style="height: 40px; width: 155px"
                :min="1"
                :max="
                  selectSkuData.extra && selectSkuData.extra.limit
                    ? selectSkuData.extra.limit
                    : 1
                "
                label="描述文字"
              />
              <span
                class="pre"
                v-if="selectSkuData.extra && !selectSkuData.extra.limit"
              >
                {{
                  selectSkuData.stockQuantity > numberGoods ? "有货" : "无货"
                }}
              </span>
              <span
                class="limit"
                v-if="selectSkuData.extra && selectSkuData.extra.limit"
              >
                限购{{ selectSkuData.extra.limit }}件
              </span>
            </div>
            <!-- 降价拍应价 -->
            <div
              class="btnBox"
              v-if="isFreeFall && isBond && activityStatus !== 2"
            >
              <div class="btn bid" @click="ansWer">应价</div>
            </div>
            <!--s 拍卖活动按钮区域 -->
            <div v-else-if="activityType === 20" class="auction-btn-box">
              <spButton
                :type="'sp-' + getStateToBtn.type"
                @click="getStateToBtn.click"
                :disabled="getStateToBtnDisabled"
                >{{ getStateToBtn.text }}</spButton
              >
            </div>

            <!--e 拍卖活动按钮区域 -->
            <div v-else>
              <div class="btnBox">
                <div
                  class="btn signUp"
                  @click="submitDeposit"
                  v-if="
                    isActivity
                      ? pageData.activityItemInfoDto.activityInfoDto
                        ? pageData.activityItemInfoDto.activityInfoDto
                            .activityStatus === 1 &&
                          pageData.activityItemInfoDto.activityInfoDto
                            .realEndTime > now &&
                          !isBond &&
                          pageData.activityItemInfoDto.activityInfoDto
                            .activityType === 20
                          ? true
                          : false
                        : false
                      : false
                  "
                >
                  报名交保证金
                </div>
                <div
                  class="btn bid"
                  :class="{ disBtn: getAuctionState === 0 }"
                  @click="auctionOffer"
                  v-if="
                    !isFreeFall &&
                    isBond &&
                    isActivity &&
                    !(
                      pageData.activityItemInfoDto.activityInfoDto
                        .activityStatus === 2 ||
                      pageData.activityItemInfoDto.activityInfoDto.realEndTime <
                        now
                    )
                  "
                >
                  出价
                </div>

                <!-- 因为之前的人写的太乱了，单独把接口拎出去 -->
                <div
                  v-if="activityType === 21"
                  class="shop addShop"
                  @click="addToCart(activityType)"
                >
                  <img src="../../assets/images/activity/shop.png" />
                  <p>加入购物车</p>
                </div>
                <div v-else>
                  <div
                    class="shop addShop"
                    @click="
                      addShop(
                        pageData.activityItemInfoDto &&
                          pageData.activityItemInfoDto.activityInfoDto &&
                          pageData.activityItemInfoDto.activityInfoDto
                            .realEndTime,
                        now
                      )
                    "
                    v-if="
                      isActivity
                        ? pageData.activityItemInfoDto.activityInfoDto
                          ? pageData.activityItemInfoDto.activityInfoDto
                              .activityStatus === 1 &&
                            pageData.activityItemInfoDto.activityInfoDto
                              .realEndTime > now &&
                            pageData.activityItemInfoDto.activityInfoDto
                              .activityType !== 6 &&
                            pageData.activityItemInfoDto.activityInfoDto
                              .activityType !== 20
                            ? true
                            : false
                          : true
                        : true
                    "
                  >
                    <img src="../../assets/images/activity/shop.png" />
                    <p>加入购物车</p>
                  </div>
                </div>
                <div
                  v-if="
                    isActivity
                      ? pageData.activityItemInfoDto.activityInfoDto
                        ? pageData.activityItemInfoDto.activityInfoDto
                            .activityStatus === 1 &&
                          pageData.activityItemInfoDto.activityInfoDto
                            .realStartTime > now &&
                          pageData.activityItemInfoDto.activityInfoDto
                            .activityType !== 20 &&
                          pageData.activityItemInfoDto.activityInfoDto
                            .activityType !== 22
                          ? true
                          : false
                        : false
                      : false
                  "
                  class="btn pay ready"
                  style="background: #d7d7d7"
                  @click="showReady"
                  :disabled="true"
                >
                  即将开始
                </div>
                <!-- 拍卖活动 -->
                <div v-if="activityType === 20">
                  <!-- 拍卖活动结束才显示+ 如果自己拍成功隐藏当前按钮-->
                  <div v-if="getAuctionState === 2">
                    <div
                      v-if="!getThisCar"
                      class="btn pay ready"
                      style="background: #d7d7d7"
                      @click="showEnd"
                    >
                      活动已结束
                    </div>
                  </div>
                </div>
                <div v-else>
                  <div
                    v-if="
                      isActivity
                        ? pageData.activityItemInfoDto.activityInfoDto
                          ? pageData.activityItemInfoDto.activityInfoDto
                              .activityStatus === 2 ||
                            pageData.activityItemInfoDto.activityInfoDto
                              .realEndTime < now
                            ? true
                            : false
                          : false
                        : false
                    "
                    class="btn pay ready"
                    style="background: #d7d7d7"
                    @click="showEnd"
                    :disabled="true"
                  >
                    活动已结束
                  </div>
                </div>

                <div
                  v-if="
                    isActivity
                      ? pageData.activityItemInfoDto.activityInfoDto
                        ? (pageData.activityItemInfoDto.activityInfoDto
                            .activityStatus === 1 &&
                            pageData.activityItemInfoDto.activityInfoDto
                              .realEndTime > now &&
                            pageData.activityItemInfoDto.activityInfoDto
                              .realStartTime < now &&
                            pageData.activityItemInfoDto.activityInfoDto
                              .activityType !== 20) ||
                          ((pageData.activityItemInfoDto.activityInfoDto
                            .activityStatus === 2 ||
                            pageData.activityItemInfoDto.activityInfoDto
                              .realEndTime < now) &&
                            pageData.activityItemInfoDto.activityInfoDto
                              .activityType === 20 &&
                            isLeader) ||
                          pageData.activityItemInfoDto.activityInfoDto
                            .activityType == 22
                          ? true
                          : false
                        : true
                      : true
                  "
                  class="btn pay"
                  :class="{ disBtn: isPurchaseSuccess }"
                  @click="payShop"
                >
                  {{
                    pageData.activityItemInfoDto.activityInfoDto
                      .activityType !== 6
                      ? pageData.activityItemInfoDto &&
                        pageData.activityItemInfoDto.activityInfoDto &&
                        pageData.activityItemInfoDto.activityInfoDto
                          .activityType === 2
                        ? " 立即预订"
                        : " 立即购买"
                      : "立即参团"
                  }}
                </div>

                <!-- <div class="btn recommend">推荐有礼</div> -->
                <Recommend
                  v-if="
                    !isActivity ||
                    (pageData.activityItemInfoDto.activityInfoDto &&
                      pageData.activityItemInfoDto.activityInfoDto.realEndTime >
                        now &&
                      pageData.activityItemInfoDto &&
                      pageData.activityItemInfoDto.activityInfoDto &&
                      pageData.activityItemInfoDto.activityInfoDto
                        .activityType == 5)
                  "
                ></Recommend>
              </div>
            </div>
          </div>

          <distributor
            ref="distributor"
            :codes="dealerCodes"
            :show.sync="dealer"
            :sellOf="pageData.itemCode"
            @dealerData="dealerData"
            :isNewretail="isNewretail"
          ></distributor>
        </div>
      </div>
      <!-- 搭配购 -->
      <CollocationPurchase
        ref="collocationRef"
        :dealerId="dealerId"
        :checkSkuId="checkSkuId"
        v-if="pageData.activityItemInfoDto.activityInfoDto.activityType === 2"
        :commondityDetail="commondityDetail"
        :noStart="
          pageData.activityItemInfoDto.activityInfoDto.realStartTime > now
        "
      ></CollocationPurchase>
      <!--s 买赠 -->
      <giftArea
        :giftData="getAllGiftProData"
        v-if="activityType === 21"
        @getGiftData="getGiftData"
      ></giftArea>
      <!--e 买赠 -->
      <div
        class="auction-process"
        v-if="
          pageData.activityItemInfoDto &&
          pageData.activityItemInfoDto.activityInfoDto &&
          pageData.activityItemInfoDto.activityInfoDto.activityType === 20
        "
      >
        <img :src="isFreeFall ? actionImg : processImg" />
      </div>
      <!-- 竞拍流程 -->
      <AuctionProcess
        v-if="
          pageData.activityItemInfoDto &&
          pageData.activityItemInfoDto.activityInfoDto &&
          pageData.activityItemInfoDto.activityInfoDto.realStartTime < now &&
          pageData.activityItemInfoDto.activityInfoDto.activityType === 20 &&
          isBond
        "
        :tableData="tableData"
        :total="offerTotal"
        :isFreeFall="isFreeFall"
      ></AuctionProcess>
      <Parameter
        :activityTypeDesc="
          isActivity
            ? pageData.activityItemInfoDto.activityInfoDto
              ? pageData.activityItemInfoDto.activityInfoDto.activityTypeDesc
              : ''
            : ''
        "
        :itemStoreDetailData="itemStoreDetailData"
        :itemDetailData="itemDetailData"
        :genre="titleList"
        :itemCode="pageData.outerId"
      ></Parameter>
      <!-- 隐藏拆红包入口 -->
      <!-- <div class="suspension" @click="getUrl" v-if="activityShow">
        <img src="../../assets/activity.png" />
      </div> -->
    </div>
    <!-- 销售体验师 -->
    <saleExperiencer :orgId="dealerId" v-if="false"></saleExperiencer>
  </div>
</template>

<script>
// import Breadcrumb from '../../components/layout/breadcrumb.vue'
import car from './components/car.vue'
import sku from '@/components/common/sku-new.vue'
import Parameter from '@/components/common/parameter.vue'
import distributor from '../../components/business/mall/distributor.vue'
import { Loading } from 'element-ui'
import getData from '@/api/details'
import Recommend from '@/components/business/mall/recommend.vue'
// import Login from '@/components/business/login/loginBox'
import Coupon from './components/coupon.vue'
import store from '@/lib/store'
// import CountDown from '@/components/common/CountDown'
import Activity from './components/activity'
import DepositDesc from './components/depositDesc'
import Deposit from './components/deposit'
import AuctionInformation from './components/auctionInformation'
import AuctionProcess from './components/auctionProcess'
import orderApi from '@/api/order.js'
import { getStorage } from '@/lib/utils'
import mAuction from '@/views/details/mixins/mAuction.vue'
// 买赠
// import gift from './components/gift.vue'
import CollocationPurchase from './components/collocationPurchase'
import storeMain from '../../store'
import giftArea from './components/giftArea.vue'
import saleExperiencer from '@/components/business/mall/sales-experiencer.vue'
import FreeCountdown from '@/components/common/freeFall-count'
import processImg from '@/assets/images/activity/auction/process.png'
import actionImg from '@/assets/images/activity/auction/process-action.png'

// import AuctionFreePrice from './components/auctionFreePrice.vue'

export default {
  name: 'allCar',
  mixins: [mAuction],
  components: {
    car,
    sku,
    Parameter,
    distributor,
    Recommend,
    Coupon,
    /* CountDown, */ Activity,
    DepositDesc,
    Deposit,
    CollocationPurchase,
    AuctionInformation,
    AuctionProcess,
    // gift,
    giftArea,
    saleExperiencer,
    FreeCountdown
  },
  data() {
    return {
      checkSkuId: '',
      activityTag: {
        2: '搭配购',
        3: '抽奖类',
        5: '限时抢购',
        6: '团购',
        8: '集客',
        9: '主题',
        10: '投票',
        11: '裂变',
        14: '签到集卡',
        16: '邀请下单',
        18: '预售',
        19: '神券',
        20: '拍卖',
        21: '买赠'
      },
      itemStoreDetailData: [],
      dealerCodes: [],
      activityPrice: 0,
      activityShow: false,
      linkActUrl: '',
      isActivity: false,
      now: '' /* 当前时间戳 */,
      activityQuantity: 0,
      selectCoupon: {},
      itemCategory: [],
      couponShow: false,
      dialogVisible: false,
      couponList: [],
      titleList: [
        { title: '购车流程', isActive: true },
        { title: '车型亮点', isActive: false },
        { title: '配置参数', isActive: false }
      ],
      itemDetailData: [],
      isLogin: false,
      dealerName: '',
      skuData: {},
      // activityId: this.$route.query.activityId,/* 联调时打开 */
      activityId: '',
      selectSkuData: {},
      pageData: {
        activityItemInfoDto: {
          activityInfoDto: {}
        }
      }, // 当前商品的基本数据
      carOutList: [], // 360车辆外部图
      carInUrl: [], // 360车辆内部链接
      activityTypeCode: null,
      numberGoods: 1, // 商品数量
      dealer: false,
      dealerId: '',
      dealerCode: '',
      isNewretail: '',
      images: [], // 图
      imagesIndex: 0, // 图
      skuItemIds: [],
      allStockQuantity: 0,
      parentId: 0, // 父id，主商品parentId=0，子商品parentId=-1
      activityType: '', // 订金升档type
      preSaleDto: {}, // 订金升档数据
      selectIndex: this.$route.query.ladderIndex
        ? this.$route.query.ladderIndex
        : 0, // 定金升档档次
      ifOrder: this.$route.query.ifOrder, // 是否可直接下订
      commondityDetail: {}, // 当前商品的详情
      bid: 0, // 出价
      bidNumber: 0, // 出价最小值
      bondInfo: {}, // 需要传递到交纳保证金页面的数据
      isBond: false,
      currentOfferPrice: '', // 当前出价
      tableData: [], // 拍卖记录
      leader: {}, // 存储领先者的用户信息
      isLeader: false, // 判断当前用户是否是领先者
      // 出价总数量
      offerTotal: 0,
      increasePrice: 0, // 加价幅度
      // 拍卖数据
      auctionInfoData: {
        currentPrice: '0',
        auctionRecordList: []
      },
      isPurchaseSuccess: false,
      watchCount: 0,
      timeout: null,
      priceTimer: null,
      activityData: {
        enrollCount: '',
        bidCount: ''
      },
      // 选中的赠品
      selectGift: [],
      isFreeFall: false, // 是否降价拍
      auctionDto: null,
      isRefresh: true,
      auctionData: {},
      firstSku: {},
      activityStatus: null,
      processImg: processImg,
      actionImg: actionImg,
      orderFlag: false // 判断拍卖是否购买过
    }
  },
  store,
  watch: {
    // (to, from) {}
    $route(to, from) {
      this.fetchData()
      this.selectSkuData = {}
      this.skuItemIds = []
    }
  },

  computed: {
    cartLists() {
      return this.$store.state.cartFloatList
    },
    // 获取当前用户是否拍到这商品
    getThisCar() {
      let useInfo = JSON.parse(window.localStorage.getItem('userInfo'))
      return this.auctionInfoData.auctionRecordList.some((item, index) => {
        if (item.bidStatus === '领先') {
          return useInfo.accountId === item.userId
        }
      })
    },
    /**
     * 判断商品是否流拍 （单出价等于保留价时候商品流拍）
     */
    isCarStreaming() {
      // 保留价
      let reservePrice = this._get(
        this.pageData,
        'activityItemInfoDto.auctionDto.reservePrice'
      )
      if (this.getThisCar) {
        if (reservePrice) {
          // 没有流拍
          return reservePrice < this.auctionInfoData.currentPrice
        }
      }
      return false
    },
    /**
     * 展示当前价后面的文本
     * 无人竞拍时 金额后方不展示文案
     * 本人是最高价时 后方展示“已领先”
     * 本人非最高价时 后方展示”已出局"
     */
    showText() {
      let obj = {
        show: false,
        text: ''
      }
      // 不报名也不显示
      if (this.isBond) {
        if (this.activityData.bidCount <= 0) {
          return obj
        } else if (this.getThisCar) {
          obj.show = true
          obj.text = '已领先'
          return obj
        } else {
          obj.show = true
          obj.text = '已出局'
          return obj
        }
      }
      return obj
    },
    getAllGiftProData() {
      let giftProData = this._get(
        this.pageData,
        'activityItemInfoDto.bogofItemList',
        []
      )
      giftProData.forEach((item, index) => {
        item.choice = false
      })
      return giftProData
    },
    isAuction() {
      if (
        this.activityStatus === 2 &&
        !this.pageData.activityItemInfoDto.auctionDto.orderFlag
      ) {
        return false
      } else {
        return true
      }
    }
  },
  created() {
    this.fetchData()
    window.Countly.q.push([
      'add_event',
      {
        key: 'pc#details',
        segmentation: {
          ea: '浏览详情页',
          ds_: 'web',
          tid: 10,
          in_: this.$route.query.id,
          dl: window.location.href,
          host: window.location.host,
          utt: window.localStorage.getItem('windowStartTime')
            ? new Date().getTime() -
              window.localStorage.getItem('windowStartTime')
            : 0,
          media: 100012,
          uid: getStorage('userInfo') && getStorage('userInfo').accountId
        }
      }
    ])
    window.localStorage.setItem('windowStartTime', new Date().getTime())
  },
  mounted() {
    // this.$nextTick(function() {
    this.$refs.distributor.getActicityDealerList()
    // })
  },
  beforeDestroy() {
    clearTimeout(this.priceTimer)
    clearTimeout(this.timeout)
  },
  methods: {
    // 选择档次
    getSelectIndex(index) {
      this.selectIndex = index
    },
    // 档次价格
    getOrderAmount(amount) {
      this.orderAmount = amount
    },
    // 是否可直接预定
    getIfOrder(ifOrder) {
      this.ifOrder = ifOrder
    },
    showReady() {
      this.$feedback('活动即将开始')
    },
    showEnd() {
      this.$feedback('活动已结束')
    },
    handleCountDown() {},
    loadingInstance(options) {
      return Loading.service(options)
    },
    dealerData(data) {
      if (data) {
        this.dealerName = data.name
        this.dealerId = data.id
        this.dealerCode = data.orgCode
        this.carDetailsData.dealerData.dealerName = data.name
        this.carDetailsData.dealerData.dealerId = data.id
        this.carDetailsData.dealerData.dealerCode = data.orgCode
      }
    },
    // 改变进度条的颜色
    customColorMethod(percentage) {
      if (percentage <= 50) {
        return '#F7442A'
      } else {
        return '#C6001F'
      }
    },
    // 计算进度条的百分比
    groupRate(item) {
      // fakerData
      if (
        item.activityItemInfoDto.activityInfoDto.id === '1283753320908849152' ||
        item.activityItemInfoDto.activityInfoDto.id === '1283744971492425728' ||
        item.activityItemInfoDto.activityInfoDto.id === '1308247897355059200'
      ) {
        return 100
      }
      // 只有一个阶梯的时候
      if (item.activityItemInfoDto.groupPurchaseLadderDto.ladder) {
        if (
          item.activityItemInfoDto.groupPurchaseLadderDto.ladder.length === 1
        ) {
          let current = item.activityItemInfoDto.groupPurchaseLadderDto.joinNum
          let all =
            item.activityItemInfoDto.groupPurchaseLadderDto.ladder[0]
              .participantNum
          if (!current || !all) {
            return 0
          }
          if (current >= all) {
            return 100
          } else if (current <= 0) {
            return 0
          } else {
            return parseInt((current / all) * 100)
          }
        } else if (
          item.activityItemInfoDto.groupPurchaseLadderDto.ladder.length === 2
        ) {
          // 第一阶梯
          if (
            item.activityItemInfoDto.groupPurchaseLadderDto.joinNum <
            item.activityItemInfoDto.groupPurchaseLadderDto.ladder[0]
              .participantNum
          ) {
            let current =
              item.activityItemInfoDto.groupPurchaseLadderDto.joinNum
            let all =
              item.activityItemInfoDto.groupPurchaseLadderDto.ladder[0]
                .participantNum
            if (!current || !all) {
              return 0
            }
            if (current >= all) {
              return 100 * 0.5
            } else if (current <= 0) {
              return 0
            } else {
              return parseInt((current / all) * 100 * 0.5)
            }
          } else {
            // 第二阶梯
            let current =
              item.activityItemInfoDto.groupPurchaseLadderDto.joinNum -
              item.activityItemInfoDto.groupPurchaseLadderDto.ladder[0]
                .participantNum
            let all =
              item.activityItemInfoDto.groupPurchaseLadderDto.ladder[1]
                .participantNum -
              item.activityItemInfoDto.groupPurchaseLadderDto.ladder[0]
                .participantNum
            if (!current || !all) {
              return 0 + 50
            }
            if (current >= all) {
              return 100
            } else if (current <= 0) {
              return 0 + 50
            } else {
              return parseInt((current / all) * 100 * 0.5 + 50)
            }
          }
        }
      }
    },

    // 判断当前用户是否交过保证金
    checkIfPayDeposit() {
      orderApi
        .queryPayDepositDealer({
          // 查询该用户是否已经交纳过保证金和对应经销商
          activityId: this.$route.query.activityId
        })
        .then((res) => {
          if (res.status === 200) {
            if (res.data) {
              this.carDetailsData.dealerData.dealerId = res.data.dealerCode
              this.isBond = !!res.data.hasPay
              this.getCurrentOfferAndOfferList()
              this.timedRefresh()
            }
          }
        })
      // .checkIfPayDeposit({
      //   // 查询该用户是否已经交纳过保证金
      //   activityId: this.$route.query.activityId
      // })
      // .then((res) => {
      //   if (res.status === 200) {
      //     if (res.data) {
      //       this.isBond = true
      //       this.timedRefresh()
      //     }
      //   }
      // })
    },
    /**
     * @descripttion: 获取报名人数、出价人数
     * @Author: cuiyuan
     * @Date: 2021-04-16 16:49:42
     * @param {void}
     * @return {void}
     */
    getEnrollAndTotalCount() {
      getData
        .getEnrollAndTotalCount({
          activityId: this.activityId
        })
        .then((res) => {
          if (res.status === 200) {
            this.activityData.enrollCount = res.data.enrollCount
            this.activityData.bidCount = res.data.total
            this.currentOfferPrice = res.data.currentPrice
          }
        })
    },
    /**
     * @descripttion: 获取拍卖围观人数
     * @Author: cuiyuan
     * @Date: 2021-04-16 15:14:57
     * @param {void}
     * @return {void}
     */
    getAuctionData() {
      getData
        .getActivity({
          activityId: this.activityId,
          type: 20
        })
        .then((res) => {
          if (res.status === 200) {
            this.watchCount = res.data
          }
        })
      if (!this.isBond) {
        this.getEnrollAndTotalCount()
      }
      clearTimeout(this.timeout)
      this.getAuctionDataRefrsh()
    },
    // 获取当前出价
    // currentOffer() {
    //   orderApi
    //     .currentOffer({
    //       activityId: this.$route.query.activityId
    //     })
    //     .then((res) => {
    //       if (res.status === 200) {
    //         this.currentOfferPrice = res.data
    //       }
    //     })
    // },
    // 定时刷新当前出价以及获取出价记录的接口（5s一次）
    timedRefresh() {
      let _that = this
      this.priceTimer = setTimeout(() => {
        _that.getCurrentOfferAndOfferList()
      }, 2000)
    },
    getAuctionDataRefrsh() {
      let _this = this
      this.timeout = setTimeout(() => {
        _this.getAuctionData()
      }, 2000)
    },
    // 拍卖出价
    auctionOffer() {
      // 活动未开始不可以出价
      if (this.getAuctionState === 0) return
      orderApi
        .auctionOffer({
          activityId: this.$route.query.activityId,
          offer: this.bid * 100
        })
        .then((res) => {
          if (res.status === 200) {
            if (res.data) {
              this.$feedback('出价成功！')
              // this.currentOffer()
              // this.getAuctionOfferList()
              this.getCurrentOfferAndOfferList()
              this.fetchData()
            } else {
              this.$feedback('出价失败！')
            }
          }
        })
        .catch((err) => {
          this.$feedback(err.message)
        })
    },
    // 获取拍卖出价记录
    // getAuctionOfferList() {
    //   orderApi
    //     .getAuctionOfferList({
    //       activityId: this.$route.query.activityId
    //     })
    //     .then((res) => {
    //       if (res.status === 200) {
    //         if (res.data) {
    //           this.tableData = res.data
    //           this.sortLeader()
    //         }
    //       }
    //     })
    // },
    // 判断当前用户是否是领先者
    sortLeader() {
      let user = getStorage('userInfo')
      if (this.tableData.length > 0) {
        this.tableData.forEach((item) => {
          if (item.bidStatus === '领先') {
            this.leader = item
          }
        })
        if (this.leader.userMobile === user.mobile) {
          this.isLeader = true
        } else {
          this.isLeader = false
        }
      }
    },
    fetchData() {
      const { id } = this.$route.query
      this.now = new Date().getTime()
      // this.activityId = this.$route.query.activityId
      // 获取商品信息
      const ladderIndex = this.$route.query.ladderIndex
        ? this.$route.query.ladderIndex
        : 0
      getData
        .getSku({
          itemId: id,
          // vmId: 1,
          terminal: 1,
          activityId: this.activityId ? this.activityId : null,
          ladderIndex: ladderIndex
        })
        .then(
          (res) => {
            if (Number(res.status) === 200) {
              this.commondityDetail = res.data
              // 当前商品的基本数据
              const {
                data: { item = {}, imageInfos = [] }
              } = res
              // 重新获取经销商
              this.carDetailsData.dealerData.dealerId =
                item.activityItemInfoDto &&
                item.activityItemInfoDto.auctionDto &&
                item.activityItemInfoDto.auctionDto.auctionDealerCode
              // 获取图片地址
              this.carDetailsData.imageUrl = item.mainImage
              this.bondInfo = res.data
              this.auctionData = Object.assign({}, res.data.item)

              // 红包
              // if (item.activityItemInfoDto.pcLinkActUrl) {
              //   this.activityShow = true
              //   this.linkActUrl = item.activityItemInfoDto.pcLinkActUrl
              // }
              this.pageData = Object.assign({}, this.pageData, {
                itemCode: item.itemCode || this.pageData.itemCode,
                outerId: item.outerId || this.pageData.outerId,
                itemId: item.id || this.pageData.itemId,
                name: item.name || this.pageData.name,
                advertise: item.advertise || this.pageData.advertise,
                src: item.mainImage || this.pageData.mainImage,
                lowPrice: item.lowPrice || this.pageData.lowPrice,
                highPrice: item.highPrice || this.pageData.highPrice,
                price: item.lowPrice || this.pageData.price,
                lowActivityPrice: item.activityTag
                  ? item.activityTag.lowActivityPrice
                  : item.lowPrice,
                extra: item.extra || this.pageData.extra,
                type: item.type,
                activityItemInfoDto:
                  item.activityItemInfoDto || this.pageData.activityItemInfoDto
              })
              // 降价拍活动数据
              this.auctionDto =
                res.data &&
                res.data.item &&
                res.data.item.activityItemInfoDto &&
                res.data.item.activityItemInfoDto.auctionDto
              this.isFreeFall =
                res.data &&
                res.data.item &&
                res.data.item.activityItemInfoDto &&
                res.data.item.activityItemInfoDto.auctionDto &&
                res.data.item.activityItemInfoDto.auctionDto.reducePriceAuction // 判断是不是降价拍（拍卖）
              this.firstSku =
                res.data && res.data.skus && res.data.skus[0]
                  ? res.data.skus[0]
                  : []
              this.activityStatus =
                res.data &&
                res.data.item &&
                res.data.item.activityItemInfoDto &&
                res.data.item.activityItemInfoDto.activityInfoDto
                  .activityStatus
              this.orderFlag =
                res.data &&
                res.data.item.activityItemInfoDto &&
                res.data.item.activityItemInfoDto.auctionDto &&
                res.data.item.activityItemInfoDto.auctionDto.orderFlag
              // 加价幅度
              if (
                res.data.item.activityItemInfoDto &&
                res.data.item.activityItemInfoDto.auctionDto &&
                res.data.item.activityItemInfoDto.auctionDto.increasePrice / 100
              ) {
                this.increasePrice =
                  res.data.item.activityItemInfoDto.auctionDto.increasePrice /
                  100
              }
              item.activityTags &&
                item.activityTags.details &&
                item.activityTags.details.map((res) => {
                  if (res.terminal === 1) {
                    this.itemStoreDetailData = res.details
                  }
                })
              this.isNewretail = item.extra.newRetail // 新零售
              // this.activityTypeCode = item.activityTag && item.activityTag.activityTypeCode
              if (
                item.activityItemInfoDto &&
                item.activityItemInfoDto.activityInfoDto
              ) {
                this.isActivity = true
                if (item.activityItemInfoDto.activityInfoDto) {
                  this.activityId = item.activityItemInfoDto.activityInfoDto.id
                  this.activityType =
                    this.pageData.activityItemInfoDto.activityInfoDto.activityType // 订金升档
                  this.preSaleDto =
                    this.pageData.activityItemInfoDto.preSaleDto
                }
              }
              if (
                item.activityItemInfoDto &&
                !item.activityItemInfoDto.forAllDealers
              ) {
                item.activityItemInfoDto.activityDealerDto &&
                  JSON.parse(
                    item.activityItemInfoDto.activityDealerDto.dealerInfo
                  ) &&
                  JSON.parse(
                    item.activityItemInfoDto.activityDealerDto.dealerInfo
                  ).map((res) => {
                    this.dealerCodes.push(res.code)
                  })
              }
              if (
                this._get(item, 'activityItemInfoDto.auctionDto.startPrice')
              ) {
                this.bid =
                  Number(this.currentOfferPrice) / 100 + this.increasePrice
                if (
                  this.bid <
                  Number(
                    this._get(
                      item,
                      'activityItemInfoDto.auctionDto.startPrice',
                      0
                    )
                  ) /
                    100
                ) {
                  this.bid =
                    Number(
                      this._get(
                        item,
                        'activityItemInfoDto.auctionDto.startPrice',
                        0
                      )
                    ) /
                      100 +
                    this.increasePrice
                }
                this.bidNumber = this.bid
              }
              // 商品图
              if (!this.images || !this.images.length) {
                this.images = []
                this.images.push({
                  url: this.pageData.src,
                  name: this.pageData.name
                })
              } else {
                this.images = imageInfos
              }
              this.skuData = res
              this.skuData.data.skus.map((res) => {
                this.allStockQuantity += res.stockQuantity
              })
              let token = getStorage('access_token')
              if (
                token &&
                this.pageData.activityItemInfoDto &&
                this.pageData.activityItemInfoDto.activityInfoDto &&
                this.pageData.activityItemInfoDto.activityInfoDto
                  .activityType === 20
              ) {
                this.checkIfPayDeposit()
              }
              if (
                this.pageData.activityItemInfoDto &&
                this.pageData.activityItemInfoDto.activityInfoDto &&
                this.pageData.activityItemInfoDto.activityInfoDto
                  .activityType === 20
              ) {
                this.getAuctionData()
              }
              this.getAllCarImg(item.outerId)
              this.getDetail(item.id)
            } else {
              this.commondityDetail = {}
              this.$feedback(res.message)
            }
          },
          (res) => {
            this.$feedback(res.message)
          }
        )
      // getData.getDetail({ itemId: id }).then((res) => {
      //   const {
      //     data: {
      //       itemDetailVo: { details = [] }
      //     }
      //   } = res
      //   details &&
      //     details.map((res) => {
      //       if (res.terminal === 1) {
      //         this.itemDetailData = res.details
      //       }
      //     })
      //   this.itemCategory =
      //     res.data.itemDetailVo.shopFrontCategoryVOS &&
      //     res.data.itemDetailVo.shopFrontCategoryVOS.map((res) => {
      //       return res.id
      //     })
      //   if (this.itemCategory) {
      //     this.getCouponList(this.itemCategory)
      //   }
      // })
      // detailInfoDto &&
      //   detailInfoDto.filter &&
      //   detailInfoDto.filter((item) => {
      //     const { terraceType, terraceDetails = [] } = item
      //     if (Number(terraceType) === 2) {
      //       this.itemDetailData = terraceDetails.map((item) => {
      //         return Object.assign({}, item, {
      //           show: false
      //         })
      //       })
      //     }
      //   })
    },
    getDetail(outerId) {
      // 获取商品详情
      getData.getDetail({ itemId: outerId }).then((res) => {
        const {
          data: {
            itemDetailVo: { details = [] }
          }
        } = res
        details &&
          details.map((res) => {
            if (res.terminal === 1) {
              this.itemDetailData = res.details
            }
          })
        this.itemCategory =
          res.data.itemDetailVo.shopFrontCategoryVOS &&
          res.data.itemDetailVo.shopFrontCategoryVOS.map((res) => {
            return res.id
          })
        if (this.itemCategory) {
          this.getCouponList(this.itemCategory)
        }
      })
    },
    getAllCarImg(outerId) {
      // 获取360图片
      getData.getAllCarImg({ itemId: outerId }).then((res) => {
        const { data = [], status } = res
        if (Number(status) === 200) {
          this.carOutList = data.filter((item) => Number(item.type) === 0)
          this.carInUrl = data.filter((item) => Number(item.type) === 1)
        }
      })
    },
    // 获取卡券列表
    getCouponList(item) {
      getData.getCouponList({ itemCategory: item, useState: 1 }).then((res) => {
        this.couponList = res.data.filter((attr) => attr.availableAmount > 0)
        this.selectCoupon = this.couponList[0]
      })
    },
    addShop(EndTime, now) {
      if (EndTime < now) {
        this.$feedback('活动还未开始不能加入购物车')
        return false
      }
      if (this.ifOrder === false) {
        this.$feedback('此档位不可选哦')
        return false
      }
      // const skuItemId = {
      //   parentId: this.parentId,
      //   itemId: this.$route.query.id,
      //   skuId: this.selectSkuData.id,
      //   quantity: this.numberGoods,
      //   dealerId: this.dealerId,
      //   activityId: this.activityId ? this.activityId : null
      // }
      if (this.allStockQuantity === 0) {
        this.$feedback('库存不足')
        return ''
      }
      if (!this.selectSkuData.skuId) {
        this.$feedback('请选择商品属性')
      } else if (!this.dealerId) {
        this.$feedback('请选择经销商')
      } else {
        // 获取顶部购物车中商品列表skuId
        // const skuIds = []
        // for (let i = this.cartLists.length - 1; i >= 0; i--) {
        //   skuIds.push(this.cartLists[i].cartItem.skuId)
        // }
        // this.skuItemIds = skuIds
        const originData =
          storeMain.state.commodityDetail[storeMain.state.checkCollocationId]
        const subCommodityList = this.dealCollocationCommodity()
        const skuItemId = [
          {
            activityId: this.activityId ? this.activityId : '',
            // extra: {
            //   guidePrice: this.pageData.extra.originPrice
            // },
            // guidePrice: 1000000,
            parentId: this.parentId,
            groupId: originData ? originData.groupId : '',
            itemId: this.$route.query.id,
            skuId: this.selectSkuData.skuId,
            quantity: this.numberGoods,
            dealerId: this.dealerId,
            // snapshotPrice: this.selectSkuData.price
            // guidePrice: 1000000,
            // itemId: '900',
            // skuId: 8,
            // quantity: 1,
            snapshotPrice: this.selectSkuData.price,
            // shopId: 1,
            vmId: this.selectSkuData.vmId,
            itemType: this.pageData.type,
            extra: { guidePrice: this.pageData.extra.guidePrice },
            ladderIndex: Number(this.selectIndex),
            bizCartMatchingItemCreateDTOList: subCommodityList
          }
        ]
        if (this.$route.query.groupCode) {
          skuItemId[0].groupCode = this.$route.query.groupCode
        }
        // if (this.prompt === true) {
        //   this.$feedback.success('商品已加入购物车')
        // } else {
        //   this.$feedback('请不要重复点击')
        // }
        this.loadingInstance({ fullscreen: true })
        getData.addCartGroup(skuItemId).then(
          (res) => {
            this.loadingInstance().close()
            if (res.status === 200) {
              this.$feedback.success('商品已加入购物车')
              // 判断是否添加同一商品
              if (
                this.skuItemIds.length === 0 ||
                this.skuItemIds.indexOf(this.selectSkuData.id) === -1
              ) {
                this.skuItemIds.push(this.selectSkuData.id)
                this.skuItemIds.join(',')
                this.$store.commit('cartFloatAdd')
                // this.$feedback('请不要重复添加商品')
              }
            } else {
              this.$feedback(res.message)
            }
          },
          (res) => {
            if (res.message === 'Request failed with status code 401') {
              this.loadingInstance().close()
            } else {
              this.$feedback(res.message)
            }
            this.loadingInstance().close()
          }
        )
      }
    },
    /**
     * @descripttion:
     * @Author: lujing
     * @Date: 2021-04-21 09:29:28
     * @param {void}
     * @return {Array} 返回选择的套餐中的搭配商品列表
     */
    dealCollocationCommodity() {
      // 获得当前选择的套餐数据
      const originData =
        storeMain.state.commodityDetail[storeMain.state.checkCollocationId]
      // 过滤出所有的搭配商品，组装成数组
      const subCommidityList = []
      originData &&
        originData.commoditys &&
        originData.commoditys.length > 0 &&
        originData.commoditys.forEach((commodity) => {
          if (commodity.sign === 'sub' && commodity.checked) {
            const tempObj = commodity.commodityData
            subCommidityList.push({
              itemId: tempObj.itemId, // 商品id
              itemName: tempObj.itemName, // 商品名称
              quantity: 1, // 商品数量
              skuId: tempObj.skus[0].skuId,
              snapshotPrice: tempObj.skus[0].price, // 加入购物车时的价格
              thumbnail: tempObj.skus[0].image, // 商品缩略图
              vmId: 1 // 渠道id 1.商城 2.试乘试驾 3.销售助手
            })
          }
        })
      return subCommidityList
    },
    ansWer() {
      if (this.orderFlag) {
        this.$feedback('已有用户抢先拍下正在付款中')
        return ''
      }
      this.payShop()
    },
    payShop() {
      // 如果是搭配购商品，直接跳转到搭配购详情页面
      if (
        this.pageData.activityItemInfoDto &&
        this.pageData.activityItemInfoDto.activityInfoDto &&
        this.pageData.activityItemInfoDto.activityInfoDto.activityType === 2
      ) {
        // this.commitOrder()
        this.$router.push(
          '/details/editOneCollocation?dealerId=' +
            this.dealerId +
            '&skuId=' +
            this.selectSkuData.skuId
        )
        return
      }
      // this.dealerId = this._get(this.pageData, 'activityItemInfoDto.auctionDto.auctionDealerCode', '')
      if (this.isPurchaseSuccess) return

      if (this.ifOrder === false) {
        this.$feedback('此档位不可选哦')
        return false
      }
      // 库存量不足提示
      if (this.allStockQuantity === 0) {
        this.$feedback('库存不足')
        return ''
      }
      if (this.selectSkuData.stockQuantity < 1) {
        this.$feedback('库存不足')
        return ''
      }
      let data = {}
      let itemToOrderList = [
        {
          skuId: this.selectSkuData.skuId,
          // itemId: this.pageData.itemId,
          quantity: this.numberGoods || 1,
          // dealerId: this.dealerI
          itemId: this.$route.query.id,
          activityId: [3, 25].includes(this.activityType)
            ? ''
            : this.activityId,
          dealerId: this.carDetailsData.dealerData.dealerId
        }
      ]
      let bogofItemList = this._get(
        this.pageData,
        'activityItemInfoDto.bogofItemList'
      )
      // 买赠
      if (bogofItemList) {
        // 为了判断是否是全部赠送还是选赠
        if (this.getAllGiftProData.length !== 0) {
          let mode = this.getAllGiftProData[0].mode
          let fnum = this.getAllGiftProData[0].fnum
          // 全送
          if (mode === 1) {
            if (this.selectGift.length === 0) {
              this.selectGift = this.getAllGiftProData
            }
          } else {
            // 选赠
            if (this.selectGift.length !== fnum) {
              this.$feedback('请选择赠品')
              return
            }
          }
        }
        this.selectGift.forEach((item) => {
          itemToOrderList.push({
            skuId: item.selectSKU.data.skuId,
            quantity: 1,
            itemId: item.itemId,
            dealerId: this.carDetailsData.dealerData.dealerId
          })
        })
      }
      data = {
        vmId: this.selectSkuData.vmId,
        terminal: 1,
        orderChannel: 0,
        itemToOrderList: itemToOrderList
      }
      // 抽奖活动传参校验 start
      if (this.activityType === 3) {
        data.lotteryDrawId = this.activityId
      }
      // if (this.$route.query.ladderIndex !== null && this.$route.query.ladderIndex !== undefined) {
      //   data.ladderIndex = Number(this.selectIndex)
      // }
      if (this.activityType === 18) {
        data.ladderIndex = Number(this.selectIndex)
      }
      if (this.$route.query.groupCode) {
        data.groupCode = this.$route.query.groupCode
      }
      if (!this.selectSkuData.skuId) {
        this.$feedback('请选择商品属性')
      } else if (
        !this.dealerId &&
        this.pageData.activityItemInfoDto &&
        this.pageData.activityItemInfoDto.activityInfoDto &&
        this.pageData.activityItemInfoDto.activityInfoDto.activityType !== 20
      ) {
        this.$feedback('请选择经销商')
      } else {
        this.loadingInstance({ fullscreen: true })
        getData.goBuy(data).then(
          (res) => {
            const { data, status, message } = res
            this.loadingInstance().close()
            if (status === 200) {
              window.Countly.q.push([
                'add_event',
                {
                  key: 'pc#details',
                  segmentation: {
                    ea: '立即购买',
                    ds_: 'web',
                    tid: 10,
                    in_: this.$route.query.id,
                    dl: window.location.href,
                    host: window.location.host,
                    media: 100012,
                    uid:
                      getStorage('userInfo') &&
                      getStorage('userInfo').accountId,
                    tc: data
                  }
                }
              ])
              this.$router.push({
                name: 'order-confirm',
                params: { orderId: data }
              })
            } else {
              if (message === 'trade.buy.exist.unpaid.order') {
                this.$feedback('您有订单未支付')
              } else {
                this.$feedback(message)
              }
            }
          },
          (res) => {
            if (res.message === 'Request failed with status code 401') {
              this.loadingInstance().close()
            } else {
              if (res.status === 200) {
                this.isPurchaseSuccess = true
              }
              this.$feedback(res.message)
              this.loadingInstance().close()
            }
          }
        )
        // window._dtm.push({
        //   ea: '立即购买',
        //   t: 'event',
        //   in: this.$route.query.id,
        //   ds: 'web',
        //   tid: 10,
        //   did: this.dealerCode
        // })
      }
    },
    /**
     * 搭配购下单
     */
    commitOrder() {
      // let groupId = ''
      // let itemToOrderList = []
      const data = {
        // itemToOrderList: itemToOrderList,
        // orderType: 1,
        // payType: 1,
        orderChannel: 0,
        // cartIds: carIds,
        // groupId,
        terminal: 1,
        vmId: 1
        // ladderIndex: ladderIndex
      }
      // if (this.$route.query.ladderIndex !== null) {
      //   data.ladderIndex = Number(this.selectIndex)
      // }
      if (this.activityType === 18) {
        data.ladderIndex = Number(this.selectIndex)
      }
      // 获得数据
      const currSetData = this.$refs.collocationRef.getSetData()
      data.groupId = currSetData.groupId
      data.itemToOrderList = [
        {
          skuId: this.selectSkuData.skuId,
          // itemId: this.pageData.itemId,
          quantity: this.numberGoods || 1,
          dealerId: this.dealerId,
          itemId: this.$route.query.id,
          activityId: this.activityId
        },
        ...currSetData.commodityList
      ]
      if (this.allStockQuantity === 0) {
        this.$feedback('库存不足')
        return ''
      }
      // 库存量不足提示
      if (this.selectSkuData.stockQuantity < 1) {
        this.$feedback('库存不足')
        return ''
      }
      if (!this.selectSkuData.skuId) {
        this.$feedback('请选择规格')
        // 下单
      } else {
        getData.goBuy(data).then(
          (res) => {
            const { data, status, message } = res
            this.loadingInstance().close()
            if (status === 200) {
              this.$router.push({
                name: 'order-confirm',
                params: { orderId: data }
              })
            } else if (status === 400) {
              this.loadingInstance().close()
              this.$feedback(message)
            }
            // this.mark = true
          },
          (res) => {
            if (res.message === 'Request failed with status code 401') {
              this.loadingInstance().close()
            } else {
              this.$feedback(res.message)
              this.loadingInstance().close()
            }
          }
        )
      }
    },
    changeShowCommodityIndex(index) {
      this.showCommodityIndex = index
    },
    getDataSKU(data = {}, list = []) {
      // if (!data.id) {
      //   this.$feedback('请选择其他车型')
      // }
      this.selectSkuData = data
      this.checkSkuId = data.skuId
      this.numberGoods = 1
      let activitySkuIds = []
      if (
        this.activityType !== 3 &&
        this.activityType !== 22 &&
        this.activityType !== 25
      ) {
        this.pageData.activityItemInfoDto &&
          this.pageData.activityItemInfoDto.activityItemDtoList &&
          this.pageData.activityItemInfoDto.activityItemDtoList.map((res) => {
            activitySkuIds.push(res.skuId)
            if (Number(res.skuId) === this.selectSkuData.skuId) {
              this.activityQuantity = res.itemExtDto.availableQuantity
              this.activityPrice = res.itemExtDto.activityPrice
              this.selectSkuData.stockQuantity =
                res.itemExtDto.availableQuantity
            }
          })
      }
      // if (activitySkuIds.indexOf(this.selectSkuData.skuId) === -1) {
      //   this.isActivity = false
      // }
    },
    getFreeFall(item, type) {
      // 活动信息
      let activityInfo =
        item &&
        item.activityItemInfoDto &&
        item.activityItemInfoDto.activityInfoDto &&
        item.activityItemInfoDto.activityInfoDto
      let rpAuctionRuleDto =
        item &&
        item.activityItemInfoDto &&
        item.activityItemInfoDto.auctionDto &&
        item.activityItemInfoDto.auctionDto.rpAuctionRuleDto // 降价拍规则拓展字段
      let cutStartTime = activityInfo && activityInfo.realStartTime // 活动开始时间

      let currentTime = new Date().getTime() // 当前时间
      let i = rpAuctionRuleDto && rpAuctionRuleDto.interval // 时间片（分钟）
      let s = (currentTime - cutStartTime) / (i * 60 * 1000)
      let T = Math.floor(s) // 已降价次数
      let cutStartPrice = rpAuctionRuleDto && rpAuctionRuleDto.startPrice // 起拍价
      let lowestPrice = rpAuctionRuleDto && rpAuctionRuleDto.lowestPrice // 最低价
      let range = rpAuctionRuleDto && rpAuctionRuleDto.reduceStep / 100 // 降价幅度
      let cutPrice
      if (cutStartPrice - T * range <= lowestPrice) {
        cutPrice = lowestPrice
      } else {
        let price = cutStartPrice - T * range * 100 // 降价拍当前价
        cutPrice = price && price > lowestPrice ? price : lowestPrice
      }
      let T2 = (currentTime - cutStartTime) % (i * 60 * 1000) // 当前区间（时间片）已经过去的时间
      let residueTime = i * 60 * 1000 - T2 // 剩余时间（距离下次降价剩余时间）
      if (type === 1) {
        return cutPrice / 100 // 降价拍当前价
      } else if (
        type === 0 &&
        cutPrice - lowestPrice > lowestPrice &&
        residueTime >= 0
      ) {
        return residueTime / 1000 // 剩余时间（距离下次降价剩余时间）
      }
    },
    overFree() {
      this.isRefresh = false
      this.$nextTick(() => {
        this.isRefresh = true
      })
    },
    getUrl() {
      window.open(this.linkActUrl, '_blank')
    },
    // 获取当前出价和获取拍卖出价记录
    getCurrentOfferAndOfferList() {
      let _that = this
      orderApi
        .getCurrentOfferAndOfferList({
          activityId: this.$route.query.activityId
        })
        .then((res) => {
          if (res.status === 200) {
            if (res.data) {
              // 获取当前出价
              this.currentOfferPrice = res.data.currentPrice
              if (res.data.auctionRecordList.length === 0) {
                this.bid = Number(this.currentOfferPrice) / 100
              } else {
                this.bid =
                  Number(this.currentOfferPrice) / 100 + this.increasePrice
              }
              this.bidNumber = this.bid
              this.tableData = res.data.auctionRecordList
              this.offerTotal = res.data.total
              this.sortLeader()
              Object.assign(this.auctionInfoData, res.data)
              this.activityData.enrollCount = res.data.enrollCount
              this.activityData.bidCount = res.data.total
            }
          }
          clearTimeout(this.priceTimer)
          _that.timedRefresh()
        })
    },
    /**
     * @Author: linyl
     * @descripttion:  获取买赠商品信息
     * @Date: 2021-04-20 13:20:57
     * @param {data}
     * @return {void}
     */
    getGiftData(data) {
      this.selectGift = data.filter((item) => {
        return item.choice
      })
    },

    /**
     * @Author: linyl
     * @descripttion: 加入购物车
     * @Date: 2021-04-20 16:54:30
     * @param {*} type
     * @param {*} state
     * @return {*}
     */
    addToCart(type, state) {
      if (this.ifOrder === false) {
        this.$feedback('此档位不可选哦')
        return false
      }
      if (this.allStockQuantity === 0) {
        this.$feedback('库存不足')
        return ''
      }
      if (!this.selectSkuData.skuId) {
        this.$feedback('请选择商品属性')
      } else if (!this.dealerId) {
        this.$feedback('请选择经销商')
      } else {
        if (this.selectSkuData.skuId) {
          if (this.getAllGiftProData.length !== 0) {
            let mode = this.getAllGiftProData[0].mode
            let fnum = this.getAllGiftProData[0].fnum
            // 全送
            if (mode === 1) {
              if (this.selectGift.length === 0) {
                this.selectGift = this.getAllGiftProData
              }
            } else {
              // 选赠
              if (this.selectGift.length !== fnum) {
                this.$feedback('请选择赠品')
                return
              }
            }
          }
          // 赠品
          let bizCarList = []

          this.selectGift.forEach((item) => {
            let obj = {
              // 活动id
              activityId: this.activityId ? this.activityId : '',
              // 渠道id 1.商城 2.试乘试驾 3.销售助手
              vmId: item.selectSKU.data.vmId,
              // 父id
              parentId: this.parentId,
              // 商品id
              itemId: item.itemId,
              skuId: item.selectSKU.data.skuId,
              // 加入购物车时的价格
              snapshotPrice: item.selectSKU.data.extraPrice.skuPrice,
              // 商品缩略图
              thumbnail: item.selectSKU.data.image,
              // 购买数量默认是1
              quantity: 1,
              itemName: item.itemName
            }
            bizCarList.push(obj)
          })

          // 购物车入参
          const skuItemId = [
            {
              // 活动id
              activityId: this.activityId ? this.activityId : '',
              // 父id
              parentId: this.parentId,
              // 商品id
              itemId: this.$route.query.id,
              // skuId
              skuId: this.selectSkuData.skuId,
              // 商品数量id
              quantity: this.numberGoods,
              // 经销商id
              dealerId: this.dealerId,
              // 加入购物车时的价格
              snapshotPrice: this.selectSkuData.price,
              // 渠道id 1.商城 2.试乘试驾 3.销售助手
              vmId: this.selectSkuData.vmId,
              // 商品类型
              itemType: this.pageData.type,
              // 扩展信息(该参数为map) 赠品放在这里
              extra: {},
              // 阶梯下标
              ladderIndex: Number(this.selectIndex),
              // 搭配购或者赠品
              bizCartMatchingItemCreateDTOList: bizCarList
            }
          ]
          this.loadingInstance({ fullscreen: true })
          getData.addCartGroup(skuItemId).then(
            (res) => {
              this.loadingInstance().close()
              if (res.status === 200) {
                this.$feedback.success('商品已加入购物车')
                // 判断是否添加同一商品
                if (
                  this.skuItemIds.length === 0 ||
                  this.skuItemIds.indexOf(this.selectSkuData.id) === -1
                ) {
                  this.skuItemIds.push(this.selectSkuData.id)
                  this.skuItemIds.join(',')
                  this.$store.commit('cartFloatAdd')
                  // this.$feedback('请不要重复添加商品')
                }
              } else {
                this.$feedback(res.message)
              }
            },
            (res) => {
              if (res.message === 'Request failed with status code 401') {
                this.loadingInstance().close()
              } else {
                this.$feedback(res.message)
              }
              this.loadingInstance().close()
            }
          )
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// .clear {
//   clear: both;
// }
.progress-bar {
  width: 100%;
  height: 108px;
  box-sizing: border-box;
  margin-top: 10px;
  .progress-text {
    width: 75px;
  }
  .progress-text-begin {
    width: 75px;
    color: #252525;
  }
  .progress-text:nth-of-type(2) {
    display: inline-block;
    width: 57px;
    // text-align: center;
  }
  .progress-text:last-of-type {
    text-align: right;
  }
  .progress-top {
    font-size: 16px;
    color: #d20c33;
    display: flex;
    justify-content: space-between;
    line-height: 24px;
  }
  .progress-center {
    margin: 7px 0px;
    position: relative;
    width: 100%;
    height: auto;
    .white-line {
      width: 2px;
      height: 12px;
      position: absolute;
      background-color: #fff;
      left: 50%;
      top: 50%;
      margin: -6px 0 0 -2px;
    }
  }
  .progress-bottom {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    color: #6c6c6c;
    line-height: 24px;
  }
}
.price-increase {
  display: flex;
  .title {
    margin-left: 15px;
    margin-right: 20px;
    height: 22px;
    font-size: 16px;
    color: #333333;
    line-height: 40px;
  }
  .time-title {
    margin-left: 200px;
    margin-right: 20px;
    height: 22px;
    font-size: 16px;
    color: #333333;
    line-height: 40px;
  }
  .now-price {
    font-size: 28px;
    font-weight: 500;
    color: #1e1e1e;
    line-height: 40px;
    .lead {
      font-size: 16px;
      font-weight: 500;
      color: #1e1e1e;
      line-height: 22px;
    }
  }
}
.price-num-box {
  margin-top: 36px;
  margin-left: 15px;
  .title {
    display: inline-block;
    // width: 52px;
    margin-right: 38px;
    height: 22px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 22px;
  }
  .pre {
    margin-left: 30px;
    font-size: 16px;
    color: #999999;
  }
  .limit {
    margin-left: 30px;
    padding: 0 3px;
    font-size: 16px;
    border: 1px solid #c6001f;
    color: #c6001f;
  }
}

#detailCar {
  text-align: left;
  margin: 0 auto;
  padding-bottom: 50px;
  background-color: white;
  .detailCarBox {
    width: 1360px;
    margin: 0 auto;
    overflow: hidden;
    .breadcrumb {
      margin-top: 41px;
      margin-bottom: 28px;
    }
    .routerNameBox {
      padding: 20px 0 28px 0;
      font-size: 16px;
      color: #777777;
      .routerItem {
        display: inline-block;
        .namePre {
          margin: 0 6px;
        }
        &:last-child {
          color: #333333;
        }
        .name {
          color: #777777;
        }
      }
    }

    .selectBox {
      display: flex;
      margin-bottom: 80px;
      .leftBox {
        position: relative;
        display: flex;
        min-height: 480px;
        width: 580px;
        overflow: hidden;
        .carImg {
          display: block;
          width: 480px;
          height: 480px;
        }
      }
      .rightBox {
        position: relative;
        flex: 1;
        margin-left: 40px;
        .titleBox {
          // padding-left: 15px;
          margin-bottom: 15px;
          display: flex;
          align-items: center;
          .title-right {
            position: absolute;
            right: 30px;
            top: 5px;
            .text {
              height: 22px;
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #777777;
              line-height: 22px;
              margin-right: 5px;
            }
            .price {
              height: 42px;
              font-size: 18px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #c6001f;
              line-height: 25px;
            }
          }
          .deposit-tag {
            width: 98px;
            height: 34px;
            margin-left: 5px;
          }
          .title {
            // float: left;
            height: 33px;
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 33px;
          }
          .message {
            // float: left;
            margin-top: 6px;
            margin-left: 6px;
            height: 25px;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #999999;
            line-height: 25px;
          }
          .recommend {
            min-width: 60px;
            height: 34px;
            padding: 0 10px;
            margin-left: 5px;
            // margin-top: 8px;
            color: #ffffff;
            background: linear-gradient(138deg, #f16666 0%, #df3d36 100%);
            border-radius: 3px;
            text-align: center;
            font-size: 20px;
            font-family: Helvetica;
            line-height: 34px;
            // -webkit-background-clip: text;
            // -webkit-text-fill-color: transparent;
          }
          .luckyTab {
            // display: inline-block;
            float: left;
            width: 72px;
            height: 27px;
            background: url("../../assets/images/activity/lottery/luckyDetail.png")
              no-repeat;
            background-size: 100% 100%;
            margin-left: 6px;
          }
          .pre {
            margin-left: 6px;
            font-size: 18px;
            color: #999999;
          }
        }
        .advertise {
          margin: 0 13px 15px;
          // padding-top: 17px;
          height: 22px;
          line-height: 22px;
          font-size: 20px;
          font-weight: 500;
          color: #c6001f;
        }
        .gift-advertise {
          margin-left: 14px;
          margin-bottom: 18px;
          font-size: 20px;
          font-weight: 400;
          color: #c6001f;
        }
        .activitystreamer {
          width: 740px;
          height: 52px;
          background-image: url("../../assets/images/activity/img_flashSale.png");
          background-size: 100% 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #fff;
          .left {
            .el-icon-time {
              font-size: 28px;
              margin-right: 10px;
            }
            padding-left: 20px;
            font-size: 20px;
            display: flex;
            align-items: center;
          }
          .right {
            padding-right: 40px;
            display: flex;
            font-size: 14px;
            span {
              margin-left: 3px;
            }
          }
        }
        .priceBox {
          padding: 21px 15px 14px 15px;
          background-color: #f5f5f5;
          margin-bottom: 32px;
          .priceItem {
            display: flex;
            align-items: center;
            .title {
              display: inline-block;
              margin-right: 44px;
              height: 22px;
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #777777;
              line-height: 22px;
            }
            .num {
              height: 25px;
              font-size: 18px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
              line-height: 25px;
            }
            .missPrice {
              text-decoration: line-through;
            }
          }

          .newPrice {
            padding-top: 10px;
            .title {
              margin-top: 6px;
            }
            .num {
              height: 40px;
              font-size: 28px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #c6001f;
              line-height: 40px;
            }
          }
        }
        .guide {
          height: 48px;
          line-height: 48px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          .title {
            font-size: 16px;
            color: #777777;
            margin-right: 9px;
            // margin-left: 15px;
          }
          .num {
            font-size: 18px;
            color: #333333;
          }
        }
        .operationArea {
          margin-top: 28px;
          // padding-left: 15px;
          .dealer {
            height: 36px;
            display: flex;
            font-size: 16px;
            line-height: 36px;
            margin-bottom: 40px;
            color: #777;
            cursor: pointer;
            > div {
              display: block;
              width: 48px;
              // margin-right: 7px;
            }
            .dealerInput {
              width: 272px;
              height: 40px;
              border: 1px solid #d0d0d0;
              // margin-left: 25px;
              margin-left: 16px;
              padding: 0 15px;
              color: #666;
              line-height: 40px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              box-sizing: border-box;
              background: url("../../assets/images/seller/search.png") 237px
                center no-repeat;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .numBox {
            .title {
              // margin-right: 10px;
              // display: inline-block;
              // width: 32px;
              // margin-right: 32px;
              // font-size: 16px;
              // color: #333333;
              // margin-right: 10px;
              // font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              width: 80px;
              color: #333333;
              font-size: 16px;
              height: 40px;
              line-height: 40px;
              display: inline-block;
            }
            .pre {
              margin-left: 22px;
              font-size: 16px;
              color: #999999;
            }
            .limit {
              margin-left: 22px;
              padding: 0 3px;
              font-size: 16px;
              border: 1px solid #c6001f;
              color: #c6001f;
            }
          }
          // 拍卖按钮区域
          .auction-btn-box {
            margin-top: 52px;
          }
          .btnBox {
            /*position: absolute;*/
            /*bottom: 0;*/
            display: flex;
            padding-top: 60px;
            font-size: 20px;
            .btn {
              cursor: pointer;
              display: inline-block;
              text-align: center;
              width: 205px;
              height: 45px;
              line-height: 45px;
              margin-right: 20px;
            }
            .signUp {
              width: 225px;
              height: 45px;
              background: #ff834c;
              color: #ffffff;
            }
            .bid {
              width: 225px;
              height: 45px;
              background: #c6001f;
              color: #ffffff;
            }
            .shop {
              cursor: pointer;
              // display: inline-block;
              // text-align: center;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 205px;
              height: 45px;
              // line-height: 45px;
              margin-right: 20px;
              img {
                width: 20px;
                height: 19px;
              }
              p {
                margin-left: 9px;
              }
            }
            .addShop {
              // background-color: #c6001f;
              background-color: #ff834c;
              color: white;
            }
            .pay {
              box-shadow: 0 0 1px 1px #c6001f inset;
              // background-color: #fdf4f3;
              background-color: #d8021c;
              // color: #c6001f;
              color: white;
            }
            .ready {
              box-shadow: 0 0 1px 1px #000 inset;
              // background-color: #fdf4f3;
              color: #fff;
            }
            .recommend {
              border: 1px solid #333333;
            }
          }
        }
      }
    }

    .commodityArea {
      width: 100%;
      box-shadow: 0 0 2px 2px #ebebeb inset;
      .titleBox {
        height: 56px;
        line-height: 56px;
        display: flex;
        justify-content: center;
        .titleItem {
          cursor: pointer;
          position: relative;
          padding: 0 36px;
          color: #c6001f;
          font-size: 14px;
          font-weight: 500;
          overflow: hidden;
          &:before {
            content: "";
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            height: 2px;
            background-color: #c6001f;
          }
          &:after {
            content: "";
            position: absolute;
            left: 50%;
            top: -2px;
            width: 8px;
            height: 8px;
            transform: rotate(-45deg) translate(-50%, -50%);
            background-color: #c6001f;
          }
        }
      }
      .detailBox {
        width: 100%;
        .detailBoxItem {
          width: 100%;
        }
        .mainPicture {
          position: relative;
          .more {
            position: absolute;
            top: 250px;
            left: 45%;
            cursor: pointer;
          }
          .mainPictureText {
            cursor: pointer;
            position: absolute;
            bottom: 20px;
            left: 50%;
            transform: translate(-50%, 0);
            color: #c6001f;
            font-size: 20px;
            display: flex;
            .textP {
              margin-right: 10px;
            }
          }
          .otherPicture {
            position: fixed;
            top: 54px;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: #fff;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            z-index: 10000;
            .otherPictureItem {
              display: inline-block;
              margin: 0 auto;
              width: auto;
              height: 100%;
            }
          }
        }
      }
    }
  }
  .suspension {
    position: fixed;
    top: 450px;
    right: 22px;
    img {
      width: 86px;
      height: 73px;
    }
  }
  // 拍卖 价格样式
  .priceAuction {
    padding: 0 15px;
    font-size: 16px;
    .title {
      color: #111111;
    }
    .OfficialGuidePriceBox {
      margin-bottom: 14px;
    }
    .tranPriceBox {
      line-height: 40px;
      .transactionPrice {
        font-size: 28px;
        color: #1e1e1e;
        margin-left: 28px;
      }
    }
  }
}
.disBtn {
  background-color: #d0d0d0 !important;
  color: #fff !important;
}
.auction-process {
  width: 1360px;
  height: 160px;
  margin-bottom: 40px;
  img {
    width: 100%;
    height: 100%;
  }
}
</style>
